// src/AppRoutes.tsx
//
// Router 를 포함하지 않는 라우트 정의.
// 브라우저에서는 App.tsx 가 BrowserRouter 로, 빌드 시 프리렌더링에서는
// StaticRouter 로 감싸서 같은 트리를 재사용합니다.
//
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import WorkerSupport from './pages/WorkerSupport';
import HousingSupport from './pages/HousingSupport';
import ParentingSupport from './pages/ParentingSupport';
import EducationSupport from './pages/EducationSupport';
import BusinessSupport from './pages/BusinessSupport';
import WelfareSupport from './pages/WelfareSupport';
import ProgramDetail from './pages/ProgramDetail';
import Changes2026 from './pages/Changes2026';
import Outlook2027 from './pages/Outlook2027';
import SearchPage from './pages/SearchPage';
import { PrivacyPage, TermsPage, ContactPage, NotFoundPage } from './pages/StaticPages';

const AppRoutes: React.FC = () => (
    <Routes>
        <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />

            {/* 분야별 */}
            <Route path="worker" element={<WorkerSupport />} />
            <Route path="housing" element={<HousingSupport />} />
            <Route path="parenting" element={<ParentingSupport />} />
            <Route path="education" element={<EducationSupport />} />
            <Route path="business" element={<BusinessSupport />} />
            <Route path="welfare" element={<WelfareSupport />} />

            {/* 개별 지원금 상세 */}
            <Route path="program/:slug" element={<ProgramDetail />} />

            {/* 연도별 기획 */}
            <Route path="2026" element={<Changes2026 />} />
            <Route path="2027" element={<Outlook2027 />} />

            {/* 검색 */}
            <Route path="search" element={<SearchPage />} />

            {/* 약관 */}
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="contact" element={<ContactPage />} />

            <Route path="*" element={<NotFoundPage />} />
        </Route>
    </Routes>
);

export default AppRoutes;
